export default __webpack_public_path__ + "static/media/expired-tuk-tuk.7cd53ba7.png";